export const getAddBooksData = (institutionCode) => {
  switch (institutionCode) {
    case 'MIAMINSTITUTE':
      return data_MIAMINSTITUTE;
    case 'LAURELI':
      return data_LAURELI;
    default:
      return [];
  }
};

const data_MIAMINSTITUTE = [
  {
    title: 'A challenge for the author',
    authors: ['Uta Hagen'],
    abstract:
      'A Challenge for the Actor” by Uta Hagen is a fundamental work for actors looking to deepen their craft. Through her personal experiences and teachings, Hagen provides a practical and profound approach to the acting process. The book emphasizes the importance of self-awareness, emotional connection, and total commitment to the character. With a clear focus on authenticity and emotional truth, Hagen challenges actors to push beyond conventional techniques, striving for a more complete and resonant performance',
    publication_date: '1991',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/A_Challenge_for_the_actor.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'challenge',
      'author',
      'acting',
      'act',
      'actor',
      'uta',
      'hagen',
      'performance',
      'authenticity',
      'emotional truth',
      'self-awareness',
      'character',
      'acting techniques',
      'art of acting',
      'performance challenge',
      'commitment',
      "actor's craft",
      'theatre',
      'method acting',
    ],
  },
  {
    title: 'A Dream of Passion',
    authors: ['Lee Strasberg'],
    abstract:
      "In this foundational text, Lee Strasberg—the legendary father of Method Acting—details the development and principles of his revolutionary technique. He traces its roots from the Stanislavski System and provides essential exercises for the actor's training.",
    publication_date: '1987',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/A_Dream_of_Passion.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'dream',
      'passion',
      'acting',
      'actor',
      'lee',
      'strasberg',
      'method',
      'acting',
      'stanislavski',
      'performance',
      'emotional preparation',
      'psychological realism',
      'authenticity',
      'character development',
      'acting techniques',
      'theatre',
      'training',
      'stage',
      'art',
    ],
  },
  {
    title: 'The Power of the Actor',
    authors: ['Ivana Chubbuck'],
    abstract:
      'A groundbreaking step-by-step guide to the Chubbuck Technique, a revolutionary approach to acting that teaches performers how to use their personal experiences and emotions to create powerful, authentic characters. This method combines psychological motivation with practical acting tools to achieve compelling performances.',
    publication_date: '2004',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_Power_of_the_Actor_Revised_and_Updated.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'power',
      'acting',
      'actor',
      'act',
      'ivana',
      'chubbuck',
      'chubbuck Technique',
      'character',
      'emotional preparation',
      'psychological realism',
      'script analysis',
      'performance',
      'scene work',
      'hollywood',
      'theatre',
      'audition',
      'personalization',
      'objective',
      'obstacle',
    ],
  },
  {
    title: "The Filmmaker's Eye",
    authors: ['Gustavo Mercado'],
    abstract:
      'A comprehensive guide to the language of cinema, this book explores the fundamental principles of shot composition, lighting, and camera techniques. It provides filmmakers with essential tools to create visually compelling and emotionally resonant storytelling through masterful use of cinematic language and visual design.',
    publication_date: '2019',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_Filmmakers_Eye.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'filmmakers',
      'eye',
      'gustavo',
      'mercado',
      'filmmaking',
      'cinematography',
      'shot composition',
      'camera techniques',
      'visual storytelling',
      'lighting',
      'film direction',
      'cinematic language',
      'frame composition',
      'visual design',
      'film production',
      'camera angles',
      'lens selection',
      'movement',
      'color theory',
      'visual narrative',
      'film aesthetics',
      'directing',
    ],
  },
  {
    title: 'The Color Correction Handbook',
    authors: ['Alexis Van Hurkman'],
    abstract:
      'A comprehensive professional guide to color grading and correction techniques for film, video, and digital media. This handbook covers fundamental principles, advanced workflows, and practical techniques for achieving cinematic looks, managing consistency across shots, and mastering the art of color storytelling.',
    publication_date: '2014',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_Color_Correction_Handbook.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'color',
      'correction',
      'handbook',
      'alexis',
      'van',
      'hurkman',
      'color grading',
      'color correction',
      'color theory',
      'color timing',
      'davinci resolve',
      'color science',
      'cinematic looks',
      'color workflow',
      'video editing',
      'post production',
      'color matching',
      'primary correction',
      'secondary correction',
      'scopes',
      'waveform',
      'vectorscope',
      'color management',
      'LUTs',
      'lookup tables',
    ],
  },
  {
    title: 'The Complete Guide to Film and Digital Production',
    authors: ['Lorene Wales'],
    abstract:
      'A comprehensive guide to the entire filmmaking process, covering all aspects of production from development and pre-production through post-production and distribution. This resource details the roles of crew members, production workflows, budgeting, and the integration of digital technologies in modern filmmaking.',
    publication_date: '2017',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_complete_Guide_to_digital_film_production.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'complete',
      'guide',
      'film',
      'digital',
      'production',
      'lorene',
      'wales',
      'filmmaking',
      'film production',
      'digital production',
      'pre-production',
      'post-production',
      'film budgeting',
      'production workflow',
      'film crew',
      'production roles',
      'film distribution',
      'production management',
      'film industry',
      'production process',
      'digital workflow',
      'film development',
      'production logistics',
    ],
  },
  {
    title: 'Respect for Acting',
    authors: ['Uta Hagen'],
    abstract:
      "A foundational text in actor training that presents a practical approach to the craft of acting. The book outlines essential techniques for developing believable characters, including exercises for emotional recall, physical action, and moment-to-moment truth on stage. It emphasizes the actor's dedication to authenticity and psychological realism in performance.",
    publication_date: '1973',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Respect_for_acting.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'respect',
      'acting',
      'uta',
      'hagen',
      'acting',
      'actor training',
      'character development',
      'emotional recall',
      'physical action',
      'stagecraft',
      'theatre',
      'acting techniques',
      'psychological realism',
      'authenticity',
      'moment-to-moment',
      'acting exercises',
      'performance',
      'acting theory',
      'drama',
      'theater',
      'actor preparation',
      'scene work',
      'object exercises',
    ],
  },
  {
    title: 'An Actor Prepares',
    authors: ['Konstantin Stanislavski'],
    abstract:
      "The foundational text of modern acting theory, this book presents Stanislavski's revolutionary system through the narrative of a young actor's training. It introduces core concepts such as emotional memory, the magic if, given circumstances, and objectives that transformed acting into a psychological and disciplined art form.",
    publication_date: '1936',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/An+Actor+Prepares.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'actor',
      'prepares',
      'konstantin',
      'stanislavski',
      'acting',
      'act',
      'method acting',
      'emotional memory',
      'the magic if',
      'given circumstances',
      'objectives',
      'super objective',
      'through line',
      'psychological realism',
      'actor training',
      'theatre',
      'drama',
      'character development',
      'stagecraft',
      'performance technique',
      'internal acting',
      'emotional recall',
      'concentration',
      'imagination',
    ],
  },
  {
    title: 'Building a Character',
    authors: ['Konstantin Stanislavski'],
    abstract:
      "The second book in Stanislavski's seminal acting trilogy, focusing on the external aspects of character creation. This work explores physical transformation, voice, speech, movement, and the development of a character's external traits while maintaining psychological truth. It provides practical exercises for actors to master the physical embodiment of their roles.",
    publication_date: '1950',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Building-A-Character.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'building',
      'character',
      'konstantin',
      'stanislavski',
      'acting',
      'character development',
      'physical transformation',
      'voice training',
      'speech',
      'movement',
      'external technique',
      'characterization',
      'body language',
      'physical acting',
      'stage presence',
      'actor training',
      'stanislavski system',
      'theatre',
      'drama',
      'performance',
      'embodiment',
      'gesture',
      'posture',
      'vocal projection',
      'physical expression',
    ],
  },
  {
    title: 'Creating a Role',
    authors: ['Konstantin Stanislavski'],
    abstract:
      "The third volume in Stanislavski's groundbreaking trilogy, this book focuses on the practical application of his system to specific roles and plays. It guides actors through the complete process of role development, from initial script analysis and research to rehearsal techniques and final performance, using detailed examples from classic plays.",
    publication_date: '1961',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Creating+a+role.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'creating',
      'role',
      'konstantin',
      'stanislavski',
      'acting',
      'script analysis',
      'character development',
      'rehearsal techniques',
      'role preparation',
      'stanislavski system',
      'play analysis',
      'actor preparation',
      'theatre',
      'drama',
      'performance',
      'character research',
      'subtext',
      'given circumstances',
      'objectives',
      'super objective',
      'emotional preparation',
      'scene work',
      'acting process',
      'theatrical interpretation',
    ],
  },
  {
    title: 'Audition',
    authors: ['Michael Shurtleff'],
    abstract:
      'The definitive guide to auditioning for actors, presenting the famous 12 guideposts for script analysis and performance. This book teaches actors how to make strong choices, build relationships on stage, and stand out in auditions through practical techniques for scene analysis, character development, and emotional connection.',
    publication_date: '1978',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/audition-by-michael-shurtleff.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'audition',
      'michael',
      'shurtleff',
      'acting',
      'auditioning',
      '12 guideposts',
      'script analysis',
      'casting',
      'actor',
      'audition techniques',
      'scene study',
      'character choices',
      'relationship',
      'conflict',
      'humor',
      'opposites',
      'discoveries',
      'communication',
      'competition',
      'importance',
      'theatre',
      'film',
      'television',
      'casting director',
      'performance',
    ],
  },
  {
    title: 'The Science and Art of Acting for the Camera',
    authors: ['John Howard Swain'],
    abstract:
      'A comprehensive guide that bridges the gap between stage acting and camera performance, exploring both the artistic and technical aspects of acting for film and television. The book provides practical techniques for adapting acting skills to the camera, covering emotional truth, technical requirements, and the specific demands of on-camera work.',
    publication_date: '2017',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_Science_and_Art_of_Acting_for_the_Camera.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'science',
      'art',
      'acting',
      'camera',
      'john',
      'howard',
      'swain',
      'acting',
      'camera acting',
      'film acting',
      'television acting',
      'on-camera technique',
      'emotional truth',
      'technical acting',
      'screen performance',
      'film set',
      'camera awareness',
      'subtlety',
      'continuity',
      'frame',
      'lens',
      'close-up',
      'film production',
      'audition techniques',
      'character development',
    ],
  },
  {
    title: 'Cinematography: Theory and Practice',
    authors: ['Blain Brown'],
    abstract:
      'A comprehensive guide to both the artistic and technical aspects of cinematography, covering everything from fundamental camera operations to advanced lighting techniques and visual storytelling. This book explores how cinematographers use lighting, composition, camera movement, and color to create mood, meaning, and narrative impact in film and video.',
    publication_date: '2016',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Cinematography_theory_and_practice.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'cinematography',
      'theory',
      'practice',
      'blain',
      'brown',
      'cinematography',
      'lighting',
      'camera',
      'composition',
      'visual storytelling',
      'film production',
      'camera movement',
      'color theory',
      'exposure',
      'lenses',
      'camera angles',
      'shot composition',
      'digital cinema',
      'film techniques',
      'visual design',
      'depth of field',
      'framing',
      'camera operators',
      'director of photography',
      'DP',
      'film lighting',
      'image making',
    ],
  },
  {
    title: 'Film Directing Shot by Shot',
    authors: ['Steven D. Katz'],
    abstract:
      'A visual guide to filmmaking that explores the language of cinema through storyboards, shot composition, and visual storytelling techniques. This book provides practical tools for directors to plan and visualize their films, covering continuity, camera angles, blocking, and the relationship between visual design and narrative structure.',
    publication_date: '1991',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Film_Directing_Shot_by_Shot.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'film',
      'directing',
      'shot',
      'shot',
      'steven',
      'katz',
      'film directing',
      'shot composition',
      'storyboarding',
      'visual storytelling',
      'camera angles',
      'continuity',
      'blocking',
      'scene planning',
      'visual design',
      'film language',
      'directing techniques',
      'pre-production',
      'storyboard',
      'frame',
      'cinematic space',
      'camera movement',
      'visual narrative',
      'film planning',
      'director',
      'shot list',
    ],
  },
  {
    title: 'In the Blink of an Eye',
    authors: ['Walter Murch'],
    abstract:
      'A seminal work on film editing that explores the philosophical, psychological, and practical aspects of editing. Walter Murch presents his revolutionary ideas about how editing relates to human perception, including his famous "Rule of Six" and insights on why cuts work, blink timing, and the emotional rhythm of film.',
    publication_date: '1995',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/In_the_Blink_of_an_Eye.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'blink',
      'eye',
      'walter',
      'murch',
      'film editing',
      'editing',
      'film theory',
      'editing techniques',
      'rule of six',
      'film rhythm',
      'emotional rhythm',
      'continuity editing',
      'film perception',
      'editing philosophy',
      'film psychology',
      'cutting',
      'transition',
      'timing',
      'blink',
      'film structure',
      'narrative flow',
      'post-production',
      'film making',
      'editor',
    ],
  },
  {
    title: 'Grammar of the Film Language',
    authors: ['Daniel Arijon'],
    abstract:
      'A comprehensive visual guide to the fundamental principles of film language and visual storytelling. This classic work systematically explores shot composition, camera angles, editing techniques, and visual continuity, serving as an essential reference for filmmakers seeking to master the visual vocabulary of cinema.',
    publication_date: '1976',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Grammar_of_the_film_language.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'grammar',
      'film',
      'language',
      'daniel',
      'arijon',
      'film language',
      'visual storytelling',
      'shot composition',
      'camera angles',
      'editing',
      'continuity',
      'visual grammar',
      'film techniques',
      'cinematic syntax',
      'framing',
      'camera movement',
      'scene transition',
      'visual narrative',
      'film direction',
      'cinematography',
      'storytelling',
      'film syntax',
      'visual continuity',
      'film making',
      'directing',
    ],
  },
  {
    title: 'Directing the Documentary',
    authors: ['Michael Rabiger'],
    abstract:
      'A comprehensive guide to the art and craft of documentary filmmaking, covering all stages from concept development to distribution. This book provides practical techniques for research, interviewing, shooting in real-world conditions, ethical considerations, and shaping raw footage into compelling narrative stories that reflect truth and perspective.',
    publication_date: '2015',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Directing-the-Documentary.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'directing',
      'documentary',
      'michael',
      'rabiger',
      'documentary',
      'filmmaking',
      'documentary directing',
      'non-fiction',
      'interview techniques',
      'ethical filmmaking',
      'documentary research',
      'real-world shooting',
      'story structure',
      'documentary editing',
      'cinema verite',
      'observational cinema',
      'documentary ethics',
      'fundraising',
      'distribution',
      'post-production',
      'character development',
      'truth in storytelling',
      'documentary narrative',
      'film proposal',
    ],
  },
  {
    title: "The Filmmaker's Handbook",
    authors: ['Steven Ascher', 'Edward Pincus'],
    abstract:
      'A comprehensive guide to the entire filmmaking process, from development and pre-production to distribution. This authoritative volume covers techniques for dramatic, documentary, corporate, and experimental projects, providing practical advice on shooting, lighting, sound recording, editing, and the business aspects of producing and funding a film.',
    publication_date: '2013',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The-Filmmakers-Handbook.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'filmmakers',
      'handbook',
      'steven',
      'ascher',
      'edward',
      'pincus',
      'filmmaking',
      'film production',
      'digital video',
      'cinematography',
      'lighting',
      'sound recording',
      'video editing',
      'post-production',
      'film distribution',
      'pre-production',
      'documentary',
      'DSLR',
      'film budgeting',
      'film directing',
    ],
  },
  {
    title: 'Film Production Management',
    authors: ['Bastian Clevé'],
    abstract:
      'A comprehensive guide to film production management focusing on the entire production process from development to delivery. This third edition covers contemporary practices in budgeting, scheduling, legal requirements, and international co-productions, providing essential knowledge for producers and production managers in the global film industry.',
    publication_date: '2006',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Film_Production_Management.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'film',
      'production',
      'management',
      'bastian',
      'clevé',
      'production management',
      'film budgeting',
      'production scheduling',
      'international co-productions',
      'film financing',
      'production law',
      'contracts',
      'rights clearance',
      'film insurance',
      'production planning',
      'shoot management',
      'post-production supervision',
      'film delivery',
      'producer',
      'line producer',
      'film industry',
      'global production',
    ],
  },
  {
    title: 'Acting in Film',
    authors: ['Michael Caine'],
    abstract:
      'An essential guide to film acting by acclaimed actor Michael Caine, offering practical advice and techniques for performing in front of the camera. The book covers everything from hitting marks and working with close-ups to maintaining consistency across takes and collaborating with directors and crew.',
    publication_date: '1990',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Acting_in_Film.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'acting',
      'film',
      'michael',
      'caine',
      'film acting',
      'camera technique',
      'close-up',
      'hitting marks',
      'continuity',
      'film set',
      'actor preparation',
      'screen performance',
      'film crew',
      'directing actors',
      'rehearsal',
      'take',
      'performance',
      'subtlety',
      'film industry',
      'movie making',
      'acting tips',
      'professional acting',
    ],
  },
  {
    title: 'The Business of Film',
    authors: ['Lawrence Turman', 'Stephen Fell'],
    abstract:
      'A comprehensive guide to the business and financial aspects of the film industry, covering the entire lifecycle of a film project from development and financing to distribution and marketing. This book provides practical insights into producing, deal-making, contracts, and the economic realities of getting films made and seen by audiences.',
    publication_date: '2019',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_business_of_film.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'business',
      'film',
      'lawrence',
      'turman',
      'stephen',
      'fell',
      'film business',
      'film financing',
      'film distribution',
      'producing',
      'deal-making',
      'film contracts',
      'entertainment law',
      'film marketing',
      'box office',
      'film economics',
      'production financing',
      'distribution deals',
      'film sales',
      'rights management',
      'film industry',
      'movie business',
      'financial planning',
      'revenue streams',
      'film investment',
    ],
  },
  {
    title: 'Producer to Producer',
    authors: ['Maureen A. Ryan'],
    abstract:
      'A comprehensive step-by-step guide to independent film producing that takes filmmakers through the entire production process from concept to distribution. The book provides practical tools, templates, and real-world advice on budgeting, scheduling, fundraising, crew management, and navigating the business aspects of independent filmmaking.',
    publication_date: '2017',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Producer_to_Producer.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'producer',
      'producer',
      'maureen',
      'ryan',
      'film producing',
      'independent film',
      'film budgeting',
      'production scheduling',
      'fundraising',
      'film financing',
      'crowdfunding',
      'production management',
      'film business',
      'independent producing',
      'film distribution',
      'production templates',
      'crew management',
      'film contracts',
      'pre-production',
      'post-production',
      'film festival',
      'low-budget filmmaking',
      'production forms',
    ],
  },
  {
    title: 'So You Want to Be a Producer',
    authors: ['Lawrence Turman'],
    abstract:
      'A practical guide to film producing from veteran producer Lawrence Turman, offering insider knowledge and career advice for aspiring producers. The book covers the creative, business, and leadership aspects of producing, including project selection, talent management, financing strategies, and the day-to-day realities of shepherding a film from idea to screen.',
    publication_date: '2005',
    url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/So_You_Want_to_Be_a_Producer.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'you',
      'want',
      'to be',
      'producer',
      'lawrence',
      'turman',
      'film producing',
      'producer',
      'career guide',
      'film career',
      'project development',
      'talent management',
      'film financing',
      'creative producing',
      'leadership',
      'film industry',
      'movie business',
      'producer role',
      'career advice',
      'entertainment industry',
      'film development',
      'packageing',
      'deal making',
      'hollywood',
    ],
  },
];

const data_LAURELI = [
  {
    title: 'Application of Plant-Based Molecules and Materials in Cosmetics',
    authors: ['Paulraj Mosae Mosae Selvakumar'],
    abstract:
      'With the growing demand for products that are gentle on the skin and manufactured by eco-friendly means, the field of cosmetics is witnessing a remarkable shift toward natural ingredients',
    publication_date: '2024',
    url: 'https://www.mdpi.com/2079-9284/11/6/211',
    type: '',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'Application',
      'Plant-Based',
      'Molecules',
      'Materials',
      'Cosmetics',
      'Paulraj',
      'Mosae',
      'Selvakumar',
      'growing',
      'demand',
      'natural',
      'ingredients',
      'eco-friendly',
      'skin',
      'cosmetic-products',
      'plant-derived',
      'bioactive-compounds',
      'sustainability',
      'green-chemistry',
      'formulations',
      'botanical-extracts',
      'phytochemicals',
      'beauty-products',
      'personal-care',
      'natural-cosmetics',
      'clean-beauty',
      'biomaterials',
      'skin-care',
      'environmentally-friendly',
    ],
  },
  {
    title: 'BAM Chapter 23: Methods for Cosmetics',
    authors: [
      'Jo Huang, Anthony D. Hitchins ',
      'Tony T. Tran',
      'James E. McCarron',
    ],
    abstract:
      "FDA's Bacteriological Analytical Manual (BAM) presents the agency's preferred laboratory procedures for microbiological analyses of foods and cosmetics.",
    publication_date: '2025',
    url: 'https://www.fda.gov/food/laboratory-methods-food/bam-chapter-23-methods-cosmetics',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'BAM',
      'Chapter',
      'Methods',
      'Cosmetics',
      'Jo',
      'Huang',
      'Anthony',
      'Hitchins',
      'Tony',
      'Tran',
      'James',
      'McCarron',
      'FDA',
      'Bacteriological',
      'Analytical',
      'Manual',
      'laboratory',
      'procedures',
      'microbiological',
      'analyses',
      'foods',
      'cosmetics-testing',
      'microbiology',
      'laboratory-methods',
      'regulatory',
      'quality-control',
      'safety-testing',
      'contamination',
      'microbial-analysis',
      'standard-procedures',
      'food-safety',
      'cosmetic-safety',
    ],
  },
  {
    title: 'Barbering Techniques for Hairstylists',
    authors: ['Arden Magtiza and Gary Franceschini'],
    abstract:
      'This manual serves as a guide for apprentices who desire to grow beyond their foundational haircutting knowledge and skills, and expand their knowledge to include more advanced barbering services, such as beard and moustache design, and straight razor shaves.',
    publication_date: '2021',
    url: 'https://collection.bccampus.ca/textbook/cte79aLm/',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'Barbering',
      'Techniques',
      'Hairstylists',
      'Arden',
      'Magtiza',
      'Gary',
      'Franceschini',
      'manual',
      'apprentices',
      'haircutting',
      'skills',
      'advanced',
      'barbering-services',
      'beard-design',
      'moustache-design',
      'razor-shaves',
      'grooming',
      'hair-design',
      'barber-tools',
      'styling',
    ],
  },
  {
    title: 'Cosmetics Labeling Guide',
    authors: ['Office of the Commissioner'],
    abstract:
      'The Cosmetics Labeling Guide provides step-by-step help with cosmetic labeling, with examples and answers to questions  manufacturers often ask about labeling requirements under U.S. laws and related regulations.',
    publication_date: '2021',
    url: 'https://www.fda.gov/cosmetics/cosmetics-labeling-regulations/cosmetics-labeling-guide',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'Cosmetics',
      'Labeling',
      'Guide',
      'Office',
      'Commissioner',
      'FDA',
      'labeling-requirements',
      'regulations',
      'U.S.-laws',
      'cosmetic-products',
      'manufacturers',
      'compliance',
      'packaging',
      'claims',
      'ingredient-listing',
      'labeling-rules',
      'guidelines',
      'examples',
      'instructions',
      'regulatory',
    ],
  },
  {
    title: 'Evidence-Based Massage Therapy: A Guide for Clinical Practice',
    authors: ['Richard Lebert'],
    abstract:
      'This clinical practice handbook will prove essential to massage therapists, physical therapists, chiropractors, medical doctors, psychologists and other health professionals who care for people with musculoskeletal pain. It is a living document and will be continuously updated as new research becomes available.',
    publication_date: '2018',
    url: 'https://collection.bccampus.ca/textbook/7WiDhceU/',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'Evidence-Based',
      'Massage',
      'Therapy',
      'Clinical',
      'Practice',
      'Richard',
      'Lebert',
      'handbook',
      'therapists',
      'physical-therapy',
      'chiropractic',
      'health-professionals',
      'musculoskeletal-pain',
      'treatment',
      'manual-therapy',
      'rehabilitation',
      'pain-management',
      'clinical-guidelines',
      'research',
      'healthcare',
    ],
  },
  {
    title: 'Hair Colour for Hairstylists: Level 2',
    authors: ['Arden Magtiza'],
    abstract:
      'This manual serves as a guide for apprentices with the desire to stretch beyond their foundational colour knowledge and skills so as to reach a higher level of competency. This text will walk the stylist step-by-step through many current and advanced techniques used in the industry today.',
    publication_date: '2021',
    url: 'https://collection.bccampus.ca/textbooks/hair-colour-for-hairstylists-level-2-bccampus-147/',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'Hair',
      'Colour',
      'Hairstylists',
      'Level-2',
      'Arden',
      'Magtiza',
      'manual',
      'apprentices',
      'colour-knowledge',
      'skills',
      'competency',
      'stylist',
      'techniques',
      'advanced',
      'industry',
      'hair-colouring',
      'formulation',
      'application',
      'professional',
      'training',
    ],
  },
  {
    title: 'Introductory Chemistry - 1st Canadian Edition',
    authors: ['Jessie A. Key', 'David W. Ball'],
    abstract:
      'The goal of this textbook is not to make you an expert. True expertise in any field is a years-long endeavor. Here I will survey some of the basic topics of chemistry. This survey should give you enough knowledge to appreciate the impact of chemistry in everyday life and, if necessary, prepare you for additional instruction in chemistry.Throughout each chapter, I present two features that reinforce the theme of the textbook.',
    publication_date: '2014',
    url: 'https://collection.bccampus.ca/textbook/8zgWk4FT/',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'Introductory',
      'Chemistry',
      'Canadian',
      'Edition',
      'Jessie',
      'Key',
      'David',
      'Ball',
      'textbook',
      'basic-topics',
      'chemical-principles',
      'everyday-life',
      'foundations',
      'survey',
      'instruction',
      'chapters',
      'science',
      'learning',
      'education',
      'fundamentals',
    ],
  },
  {
    title:
      'The Case for Pain Relief: 5 Research Studies for Massage Therapists',
    authors: ['Massage Theraphy Foundation'],
    abstract:
      "Likely highlights massage's benefits, showing it reduces pain, anxiety, depression, and improves strength in conditions like low back pain, cancer pain, and carpal tunnel, using evidence from studies by Field and others, indicating even short sessions with moderate pressure yield significant results, though high-certainty evidence for superiority over other active treatments is often lacking, necessitating more rigorous trials. ",
    publication_date: '2012',
    url: 'https://massagetherapyfoundation.org/wp-content/uploads/mtf-pain-relief-ebook.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'Pain',
      'Relief',
      'Massage',
      'Therapists',
      'Massage-Therapy-Foundation',
      'research',
      'studies',
      'pain-reduction',
      'anxiety',
      'depression',
      'strength',
      'low-back-pain',
      'cancer-pain',
      'carpal-tunnel',
      'moderate-pressure',
      'treatment-effects',
      'evidence',
      'clinical',
      'outcomes',
      'therapeutic-benefits',
    ],
  },
  {
    title:
      '5 Myths and Truths about Massage Therapy: Letting Go Without Losing Heart',
    authors: ['Massage Theraphy Foundation'],
    abstract:
      "Likely details common misconceptions (like massage detoxifies or is always painful) versus realities (it promotes well-being, enhances immune function, improves circulation locally, and addresses chronic pain patterns). The core idea is debunking myths to focus on proven benefits like stress reduction, pain relief, increased mobility, and supporting the body's healing, emphasizing the need for honest, evidence-based communication in the massage field. ",
    publication_date: '2016',
    url: 'https://www.tracywalton.com/wp-content/uploads/2016/09/5-Myths-and-Truths-about-Massage-Therapy_final-with-Page-Numers.pdf',
    type: 'BOOK',
    resource_origin: '',
    peer_reviewed: false,
    words: [
      'Myths',
      'Truths',
      'Massage',
      'Therapy',
      'Massage-Therapy-Foundation',
      'misconceptions',
      'evidence-based',
      'well-being',
      'immune-function',
      'circulation',
      'chronic-pain',
      'stress-reduction',
      'pain-relief',
      'mobility',
      'healing',
      'benefits',
      'education',
      'communication',
      'health',
      'therapeutic',
    ],
  },
];
